// extracted by mini-css-extract-plugin
export default {"icon":"GEcNxR232Yj8f3aemzsY3w=="};